import { Attributes, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../TemporalEntity';

export default class InvestorInvestmentInternalApproval extends TemporalEntity {
    static typeName = "InvestorInvestmentInternalApproval";

    constructor() {
        super();
        this.makeObservable();
    }

    public investorInvestmentInternalApprovalId: number = 0;

    @Attributes.Serialisation(Misc.SerialiseType.NotNull)
    public investorInvestmentApprovalId: number | null = null;

    @Rules.Required()
    public internalApproverId: number | null = null;

    @Rules.Required({allowZero: true})
    public internalApprovalEntityId: number | null = null;

    @Attributes.ChildObject(Model.UserEvent, true)
    public approved: Model.UserEvent = Model.UserEvent.None();

    @Attributes.ChildObject(Model.ReasonedUserEvent, true)
    public queried: Model.ReasonedUserEvent = Model.ReasonedUserEvent.None();

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<InvestorInvestmentInternalApproval>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew) {
            return "New required approver";
        } else {
            return "Required approver";
        }
    }
}